import {
  AfterViewInit,
  Component,
  Injector, OnInit,
  Optional, ViewChild
} from '@angular/core';
import {CommonModule} from "@angular/common";
import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {CircleProgressComponent, CircleProgressOptions, CircleProgressOptionsInterface, NgCircleProgressModule} from "ng-circle-progress";
import {clone, debounce} from "lodash-es";
import {calculatePercent, getDecimalCount, isPercentageValue} from "../../progress-bar/utils";

const DEFAULT_CLS = 'progress app-progress circle';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-progress-circle',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};
const DEFAULT_OPTIONS: CircleProgressOptionsInterface  = {
  responsive: true,
  innerStrokeWidth: 10,
  outerStrokeWidth: 10,
  unitsFontSize: '15',
  space: -10,
  toFixed: 0,
  maxPercent: 100,
  showSubtitle: false,
  clockwise: true,
  startFromZero: false,
  renderOnClick: false,
  innerStrokeColor: '',
  outerStrokeColor: '',
};

// map of progress-bar type and classes
export const TYPE_CLASS_MAP_PC: { [key:string]: string } = {
  'default': '',
  'success': 'progress-circle-success',
  'info': 'progress-circle-info',
  'warning': 'progress-circle-warning',
  'danger': 'progress-circle-danger',
};


@Component({
  selector: '[wmProgressCircle]',
  template: `<circle-progress [percent]="percentagevalue" [options]="options"></circle-progress>`,
  providers: [
    provideAsWidgetRef(ProgressCircleComponent),
    NgCircleProgressModule,
    CircleProgressOptions
  ],
  exportAs: 'wmProgressCircle',
  standalone: true,
  imports: [CommonModule, NgCircleProgressModule],
  styles: []
})
export class ProgressCircleComponent extends StylableComponent implements AfterViewInit{
  static initializeProps = register('wm-progress-circle');

  public displayformat: string;
  public datavalue: string;
  public minvalue: number;
  public maxvalue: number;
  public type: string;
  public title: string;
  public subtitle: string;
  public captionplacement: string;
  public percentagevalue: number;
  public options: CircleProgressOptions;

  @ViewChild(CircleProgressComponent, { static: true }) circleRef: CircleProgressComponent;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
    this.options = clone(DEFAULT_OPTIONS as CircleProgressOptions)
  }

  _redraw(): any{
    if(this.circleRef){
      this.circleRef.render();
    }
  }

  override ngAfterViewInit() {
    this.options = Object.assign(this.circleRef.options, this.options)
  }

  updateDisplayValueFormat(){
    // show title and subtitle only when captionplacement is 'inside'
    this.options.showTitle = this.options.showSubtitle = (this.captionplacement === 'inside')

    // show units when title value is empty and captionplacement is 'inside'
    this.options.showUnits = !this.title && this.options.showTitle && isPercentageValue(this.displayformat);
    this.options.toFixed = getDecimalCount(this.displayformat);

    if (this.options.showTitle){
      this.options.title = this.title || 'auto';
      this.options.showSubtitle = !!this.subtitle;
      this.options.subtitle = this.subtitle || '';
    }
    this._redraw();
  }

  override onPropertyChange(key: string, nv: any, ov?: any){
    switch (key){
      case 'type':
        $(this.nativeElement).removeClass(TYPE_CLASS_MAP_PC[ov]).addClass(TYPE_CLASS_MAP_PC[nv])
        break;
      case 'hint':
        $(this.nativeElement).attr('title', nv);
        break;
      case 'minvalue':
      case 'maxvalue':
      case 'datavalue':
        this.render();
        break;
      case 'title':
      case 'subtitle':
      case 'captionplacement':
      case 'displayformat':
        this.updateDisplayValueFormat();
        break;
    }
    super.onPropertyChange(key, nv, ov);
  }

  render() {
    if (isPercentageValue(this.datavalue)) {
      this.percentagevalue = parseFloat(this.datavalue);
    } else {
      this.percentagevalue = calculatePercent(parseFloat(this.datavalue), this.minvalue, this.maxvalue);
    }
    if (parseInt(this.datavalue) < 0){
      this.percentagevalue = 0
    }
  }
}

